import React, { type CSSProperties } from 'react';

import classnames from 'classnames';

import { type SizeType, useSize } from '../../features/config';
import { type ThemedColors } from '../../types/themed-colors';

import styles from './Dot.module.scss';

type DotProps = {
    className?: string;
    style?: CSSProperties;
    color?: ThemedColors;
    size?: SizeType;
    customSize?: string | number;
    children?: React.ReactNode;
};

export const Dot = ({ color, size: sizeProp, customSize, style, className, ...rest }: DotProps) => {
    const size = useSize(sizeProp, 'medium', 'Dot');
    const customSizeStyle = customSize ? { height: customSize, width: customSize } : {};
    return (
        <div
            style={{
                ...customSizeStyle,
                ...style
            }}
            className={classnames(
                styles.dot,
                !customSize && styles[size],
                color && styles[color],
                className
            )}
            {...rest}
        />
    );
};
